module.exports = __webpack_public_path__ + "static/media/WHATS_APP.6a4eb349.png";